export default __webpack_public_path__ + "static/CommSec logo-7355afed43583fd96f6d5a11b027b92d.png";